import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-38c57cde"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "grid"
};
const _hoisted_2 = { class: "col" };
const _hoisted_3 = {
    key: 1,
    class: "mt-2"
};
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { class: "flex justify-content-center align-items-center" };
const _hoisted_7 = { class: "" };
import useAuthStore from '@/store/auth.store';
import useUsersStore from '@/store/users.store';
import useMainStore from '@/store/main.store';
import useCustomersStore from '@/store/customers.store';
import router from "@/router";
import { onMounted, } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoginComponent',
    setup(__props) {
        const authStore = useAuthStore();
        const userStore = useUsersStore();
        const mainStore = useMainStore();
        const customerStore = useCustomersStore();
        var customer;
        var accountOptions = [
            { name: 'Dashboard', url: '/dashboard' },
            { name: 'Log Out', url: '/logout' },
        ];
        var selectedAction = '';
        onMounted(async () => {
            if (authStore.isActivelyLoggedIn == false)
                return;
            if (userStore.self == undefined || userStore.self.uniqueId == null)
                await userStore.fetchSelf();
            var user = userStore.self;
            if (user.customerId != null && user.customerId > 0) {
                await customerStore.getSelfCustomer();
                customer = customerStore.myCustomer;
            }
            if (user.role == "Administrator") {
                accountOptions.unshift({ name: 'My Account', url: '/account' });
            }
            else if (customer !== undefined && customer.ownerId == user.uniqueId) {
                accountOptions.unshift({ name: 'My Account', url: '/account' });
            }
            else {
                accountOptions.unshift({ name: 'My Account', url: '/subaccount' });
            }
        });
        function accountNavChanged(event) {
            router.push(event.value);
        }
        userStore.$onAction(({ onError }) => {
            onError((error) => {
                mainStore.setErrorMsg(error);
            });
        });
        return (_ctx, _cache) => {
            const _component_Button = _resolveComponent("Button");
            const _component_router_link = _resolveComponent("router-link");
            const _component_Avatar = _resolveComponent("Avatar");
            const _component_DropDown = _resolveComponent("DropDown");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (!_unref(authStore).isActivelyLoggedIn)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_router_link, {
                                style: { "text-decoration": "none" },
                                class: "flex py-3 lg:py-0 md:mt-3 lg:mt-1 lg:ml-5",
                                to: "/login"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_Button, {
                                        id: "login-button",
                                        label: "Login",
                                        icon: "pi pi-user",
                                        class: "p-button-info"
                                    })
                                ]),
                                _: 1
                            })
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_unref(authStore).isActivelyLoggedIn)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_DropDown, {
                            id: "profile-dropdown",
                            modelValue: _unref(selectedAction),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(selectedAction) ? (selectedAction).value = $event : selectedAction = $event)),
                            options: _unref(accountOptions),
                            optionLabel: "name",
                            optionValue: "url",
                            filter: false,
                            showClear: false,
                            style: { "border": "none" },
                            onChange: accountNavChanged
                        }, {
                            value: _withCtx((slotProps) => [
                                (slotProps.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(slotProps.value.name), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createElementVNode("div", _hoisted_6, [
                                            _createVNode(_component_Avatar, {
                                                icon: "pi pi-user",
                                                class: "mr-2",
                                                size: "xsmall",
                                                shape: "circle"
                                            }),
                                            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(authStore).user_name), 1)
                                        ])
                                    ]))
                            ]),
                            _: 1
                        }, 8, ["modelValue", "options"])
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
